import { VIEW } from "../../../services/shared/common";
import { ICategory } from "./overviewAlertsChart";

export enum OverviewCategory {
  Problem = "problem",
  Warning = "warning",
  Good = "good"
}

export function getCategories(path: string) {
  const CATEGORIES: ICategory[] = [
    { id: VIEW.red, name: OverviewCategory.Problem, colour: "#DC7F7F", path: `#${path}?status=red` },
    { id: VIEW.orange, name: OverviewCategory.Warning, colour: "#FBCD76", path: `#${path}?status=yellow` },
    { id: VIEW.green, name: OverviewCategory.Good, colour: "#3FA67D", path: `#${path}?status=green` }];
  return CATEGORIES;
}

export function getPercentage(value: number, total: number): string {
  const percentageValue = (value / total) * 100;
  return percentageValue < 1 ? `<1%` : `${percentageValue.toFixed(0)}%`;
}

export function typedEntries<T extends object>(
  obj: T
): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
}
